export { default as PayrollsHomePage } from './payrollsHomePage';
export { payrollsHomePageType } from './payrollsHomePage.types';
export { payrollsHomePageFragment } from './payrollsHomePage.fragment';
export { payrollsHomePageStandard } from './__fixtures__/payrollsHomePage';
